import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentStepStatusTagCtrl implements IController {

  stepDisplayStatus: string;

  constructor() {
  }

  $onInit() {
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepStatusTag', {
    bindings: {
      stepDisplayStatus: '<',
    },
    template: require('./fulfillment-step-status-tag.html').default,
    controller: fulfillmentStepStatusTagCtrl
  });
